import { IGeoJSON, IFeature } from "../types";
import _ from 'lodash';
import L from 'leaflet';

export function highlight(map: L.Map, colors: string[]) {
  const reverseCallbacks: (() => void)[] = [];
  map.eachLayer((layer) => {
    const layerFeature = layer['feature'] as IFeature | undefined;
    const style = (layer as any).defaultOptions?.style(layerFeature);
    if (colors.length && layerFeature && !colors.includes(layerFeature.properties['color'] as string)) {
      (layer as any).setStyle({ fillOpacity: 0, opacity: 0.3 });
      reverseCallbacks.push(() => {
        (layer as any).setStyle({ fillOpacity: style.fillOpacity, opacity: style?.opacity });
      });
    } else if ((layer as any).setStyle) {
      (layer as any).setStyle({ fillOpacity: style?.fillOpacity, opacity: style?.opacity });
    }
  });

  return () => reverseCallbacks.forEach(f => f());
}